/**
 * Shared constants for authentication components
 */

// Max width for form containers and authentication components
export const AUTH_FORM_MAX_WIDTH = '400px'
